module.exports = __webpack_public_path__ + "static/roboto-light-0a50dfdf3e7d6cdd6ea76b7933e86d84.woff";